import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const TagLink = ({ name, title, size }) => {

  const tagStyle = size === "s" ? "text-xs px-1 lg:py-1 lg:px-2 tracking-wide" : size === "l" ? "text-sm lg:text-base py-1 pl-3 pr-3 lg:pl-4 lg:pr-4" :
  "text-sm py-1 px-3"

  return (
    <Link
      to={`/tag/${name}`}
      key={name}
      className={`text-blue-800 bg-blue-50 border border-blue-100 inline-block font-medium rounded-full hover:opacity-70 ${tagStyle}`}
    >
      {title}
    </Link>
  )
}

TagLink.defaultProps = {
  size: "m",
}

TagLink.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['s', 'm', 'l'])
}

export default TagLink
